export default [
  'basket:create',
  'basket:read',
  'basket:update',
  'basket:delete',
  'basket:software-update',
  'users:read',
  'roles:read',
  'role:read',
  'permissios:read',
];
